import { FC } from 'react'
import { Grid, Link, Badge } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import LanguageSwitch from './LanguageSwitch'
import { RoutePaths } from '@/navigation/route'
import { useTicketsUnreadCount } from '@/hooks/useTicketsUnreadCount'

const baseContent = `&copy; Agrid ${new Date().getFullYear()}`

interface FooterProps {
    links?: { title: string; path: string; target?: string }[]
}

const Footer: FC<FooterProps> = ({ links }) => {
    const ticketsUnreadCount = useTicketsUnreadCount()
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{ height: '50px', color: 'primary.main', pb: 8 }}
            component={'footer'}
        >
            <Grid item>
                <span dangerouslySetInnerHTML={{ __html: baseContent }} />
            </Grid>
            {links?.map((link) => (
                <Grid item key={`footer-link-${link.path}`}>
                    <Link component={RouterLink} to={link.path} target={link?.target || '_self'}>
                        {link.path === RoutePaths.Tickets ? (
                            <Badge
                                color="error"
                                variant="dot"
                                invisible={!ticketsUnreadCount}
                                sx={{ '& .MuiBadge-badge': { right: -4 } }}
                            >
                                {link.title}
                            </Badge>
                        ) : (
                            link.title
                        )}
                    </Link>
                </Grid>
            ))}
            <Grid item>
                <LanguageSwitch />
            </Grid>
        </Grid>
    )
}

export default Footer
